export const getFontColor = (isDarkMode: boolean) => {
  return isDarkMode ? 'white' : 'gray';
};
